import { render, staticRenderFns } from "./TaskCosts.vue?vue&type=template&id=5d880b5e&scoped=true&"
import script from "./TaskCosts.vue?vue&type=script&lang=js&"
export * from "./TaskCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d880b5e",
  null
  
)

export default component.exports